import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import propTypes from "../../../../../../constants/propTypes";
import {
  showSnackNotificationAction,
  closeModalDialog,
} from "../../../../../../actions/layoutActions";
import {
  performDeleteRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { processDeleteRequestStatus } from "../../../../../../utils/dataComponentUtils";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import DeleteConfirmation from "../../../../../ui/DeleteConfirmation";
import { dataComponentId } from "../UserRolesTableContainer";

export class DeleteUserRoleContainer extends Component {
  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const { dataComponent, closeModalDialog, setReload } = this.props;

    processDeleteRequestStatus(prevDataComponent, dataComponent, {
      onSuccess: () => {
        closeModalDialog();
        setReload(dataComponentId, true);
      },
      onError: this.handleDeleteRequestError,
    });
  }

  handleDeleteRequestError = ({ data }) => {
    const { showSnackNotificationAction } = this.props;

    data.errors.map(error => {
      if (error.global) {
        showSnackNotificationAction(error.title);
      }
    });
  };

  handleDeleteUserRole = () => {
    const { userRoleId, performDeleteRequest } = this.props;
    performDeleteRequest(dataComponentId, userRoleId);
  };

  render() {
    const { title } = this.props;
    return (
      <DeleteConfirmation title={title} onDelete={this.handleDeleteUserRole} />
    );
  }
}

DeleteUserRoleContainer.propTypes = {
  title: PropTypes.string.isRequired,
  userRoleId: PropTypes.string.isRequired,
  dataComponent: propTypes.dataComponent.isRequired,
  performDeleteRequest: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

const mapDispatchToProps = {
  performDeleteRequest,
  closeModalDialog,
  showSnackNotificationAction,
  setReload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteUserRoleContainer);
